import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { PointerChevronLeft, PointerChevronRight } from '@box/blueprint-web-assets/icons/Fill';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { IconButton } from '../primitives/icon-button/icon-button.js';
import { useRefWithEffect as useRefWithEffectMemoized } from '../utils/useRefWithEffect.js';
import { ToolbarSeparator } from './toolbar-separator.js';
import styles from './toolbar.module.js';
import { useScrollContext } from './utils/horizontal-scroll-context.js';

var ScrollButton = function ScrollButton(_ref) {
  var hidden = _ref.hidden,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      Icon = _ref.icon,
      separatorPosition = _ref.separatorPosition;
  return jsxs("div", {
    className: clsx(styles.scrollButtonWrapper, _defineProperty({}, styles.hidden, hidden)),
    children: [separatorPosition === 'before' && jsx(ToolbarSeparator, {}), jsx(IconButton, {
      "aria-label": ariaLabel,
      icon: Icon,
      onClick: onClick
    }), separatorPosition === 'after' && jsx(ToolbarSeparator, {})]
  });
};

var ToolbarScrollableContainer = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      ariaLabelPrevButton = props.ariaLabelPrevButton,
      ariaLabelNextButton = props.ariaLabelNextButton;

  var _useScrollContext = useScrollContext(),
      scrollPosition = _useScrollContext.scrollPosition,
      scrollLeft = _useScrollContext.scrollLeft,
      scrollRight = _useScrollContext.scrollRight,
      onAttach = _useScrollContext.onAttach;

  var onMountRef = useRefWithEffectMemoized(forwardedRef, function (node) {
    onAttach(node);
  });
  return jsxs(Fragment, {
    children: [jsx(ScrollButton, {
      ariaLabel: ariaLabelPrevButton,
      hidden: scrollPosition === 'start' || scrollPosition === 'none',
      icon: PointerChevronLeft,
      onClick: scrollLeft,
      separatorPosition: "after"
    }), jsx("div", {
      ref: onMountRef,
      className: clsx(styles.scrollableChildrenWrapper),
      "data-testid": "toolbar-scroll-container",
      children: children
    }), jsx(ScrollButton, {
      ariaLabel: ariaLabelNextButton,
      hidden: scrollPosition === 'end' || scrollPosition === 'none',
      icon: PointerChevronRight,
      onClick: scrollRight,
      separatorPosition: "before"
    })]
  });
});
export { ToolbarScrollableContainer };